<app-hero-section></app-hero-section>

@defer (on viewport) {
  <app-decanting-video-banner></app-decanting-video-banner>
} @placeholder {
  <!-- Esqueleto placeholder refinado con la nueva altura proporcional -->
  <div class="w-full max-w-6xl mx-auto px-4 py-8 lg:py-16">
    <div class="h-[calc(100vh-180px)] lg:h-[650px] w-full rounded-[2.5rem] lg:rounded-[3.5rem] bg-polished-charcoal/50 animate-pulse border border-haze/10 shadow-neumorphic-dark flex flex-col justify-end p-8 lg:p-16">
      <div class="max-w-2xl space-y-6">
        <div class="h-4 w-32 bg-amethyst-glint/30 rounded-full"></div>
        <div class="h-12 w-3/4 bg-silk-white/20 rounded-xl"></div>
        <div class="space-y-3">
          <div class="h-4 w-full bg-silk-white/10 rounded"></div>
          <div class="h-4 w-5/6 bg-silk-white/10 rounded"></div>
        </div>
      </div>
    </div>
  </div>
}

<app-featured-products [products]="products$ | async" [isLoading]="isLoading$ | async"></app-featured-products>
<app-categories-highlight [categories]="categories$ | async"></app-categories-highlight>
<app-benefits></app-benefits>
<app-testimonials></app-testimonials>
<app-cta-section></app-cta-section>
